module.exports = __webpack_public_path__ + "img/Mike Jones Jr.94e53d9c.jpg";